+function ($) {
    /* ======= Owl Carousel ======= */
    $(document).ready(function(){
        // Mobileye Signals Carousel
        $('.mobileye-signals-carousel').owlCarousel({
            autoplay: false,
            autoplayTimeout: 2000,
            autoplayHoverPause: true,
            loop: true,
            margin: 0,
            nav: true,
            dots: false,
            navText: ['<span></span>','<span></span>'],
            items: 1
        });
    });

    $(document).ready(function(){
        // Mobileye Signals Carousel
        $('.reviews-carousel').owlCarousel({
            autoplay: false,
            autoplayTimeout: 2000,
            autoplayHoverPause: true,
            loop: true,
            margin: 0,
            nav: true,
            dots: false,
            navText: ['<span></span>','<span></span>'],
            items: 1
        });
    });
}(jQuery);
